import {
  CheckoutCardProvider,
  CheckoutDirectDebitMethod,
  WorldpayTransactionSource,
  WorldpayTransactionType,
} from '@checkout';
import {
  ClientBrandCode,
  RequestAction,
  RequestSource,
  TrustBox,
} from '@common';
import { BuildConfig, DomainId } from '@config';

export const buildConfig: BuildConfig = {
  applianceRegistrationLimit: 10,
  appVariantConfigPath: 'gb/sidedoor-sda',
  buildFeatures: {},
  checkout: {
    card: {
      customisation: {
        buttons: {
          backgroundColor: '#038ad3',
          border: {
            style: 'solid',
            color: '#038ad3',
            width: '5px',
            radius: '2px',
          },
          color: '#fff',
          hover: {
            backgroundColor: '#0071bb',
            border: {
              color: '#0071bb',
            },
          },
        },
        color: '#414141',
        fonts: {
          family: ['Museo Sans', 'Source Sans Pro', 'Arial'],
        },
        inputs: {
          backgroundColor: '#ffffff',
          border: {
            style: 'solid',
            width: '1px',
            radius: '2px',
            color: '#757575',
          },
          placeholder: {
            color: '#001',
          },
          validation: {
            ok: {
              color: '#228415',
            },
            error: {
              color: '#af2c2b',
            },
          },
        },
        page: {
          backgroundColor: '#fff',
          color: '#333',
          border: {
            style: 'solid',
            color: '#ddd',
            width: '1px',
            radius: '2px',
          },
        },
      },
      iframeHelperURL: 'http://localhost:4200/assets/worldpay/helper.html',
      provider: CheckoutCardProvider.Worldpay,
      transactionDescription: 'Sales',
      transactionSource: WorldpayTransactionSource.Web,
      transactionType: WorldpayTransactionType.Web,
    },
    directDebit: {
      method: CheckoutDirectDebitMethod.AccountNumberSortCode,
    },
  },
  defaultDomainId: DomainId.Beko,
  domainIdMapping: {
    [DomainId.Beko]: /beko\.[\w.-]*partners/,
  },
  modelNumberSearchEnabledBrands: [ClientBrandCode.Beko],
  retailerFieldEnabledBrands: [ClientBrandCode.Beko],
  trustpilot: {
    businessUnitId: '4cb3113600006400050dfb02',
    templates: [
      { id: '5419b6ffb0d04a076446a9af', name: TrustBox.Micro },
      { id: '54ad5defc6454f065c28af8b', name: TrustBox.Slider },
    ],
  },
  requestAction: RequestAction.SdaOnlineRegistration,
  whiteLabelClient: RequestSource.DomesticAndGeneralUK,
};
